import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, post } from '@api/request';
import { mdtkAPI } from '@api/modules/mdtk';
import { mqcdAPI } from '@api/modules/mqcd';
import pubPagination from '@/components/common/pubPagination';
import selectSectionType from '@/views/component/selectSectionType';
import helper from '@assets/js/helper.js';
export default {
  name: 'MdtkList',
  components: {
    pubPagination: pubPagination,
    selectSectionType: selectSectionType
  },
  data: function data() {
    return {
      title: '查看二维码信息',
      tableData: [],
      dialogVisible: false,
      searchForm: {
        mdrl_no: null,
        mdrl_thick: null,
        mdrl_sort: null,
        mdrl_type: null,
        flag: 0,
        mdrl_width: null,
        //材料门幅
        mdrl_spec: null,
        //材料规格
        mdrl_field: null,
        colr_class: [],
        timeValue: [],
        mdtk_status: null,
        belo_dept_id: null //所属部门

      },
      qrCodeList: [],
      qr_mdrl_id: null,
      totalPage: 0,
      btn: {},
      loadFlag: true,
      currentPage: 1,
      mdrlType: [{
        id: 1,
        label: '主材料'
      }, {
        id: 2,
        label: '辅材料'
      }, {
        id: 3,
        label: '其他'
      }],
      state: [{
        id: 0,
        label: '库存不足'
      }, {
        id: 1,
        label: '库存充足'
      }],
      multipleSelection: [],
      optnColorList: [],
      isDyj: true,
      beloDeptId: null
    };
  },
  created: function created() {
    if (this.$route.query.mdrl_no) {
      this.searchForm.mdrl_no = this.$route.query.mdrl_no;
    }

    this.initData();
  },
  mounted: function mounted() {
    var _this = this;

    this.$EventBus.$on('uploading', function (res) {
      _this.getMdtksList();
    });
  },
  filters: {
    formatMdtkNum: function formatMdtkNum(row) {
      return helper.haveFour(row);
    },
    formatMdrlStockLimit: function formatMdrlStockLimit(row) {
      return helper.haveFour(row);
    },
    formatQrcdMdrlThick: function formatQrcdMdrlThick(row) {
      return helper.reservedDigits(row);
    },
    formaUnitM: function formaUnitM(row) {
      return helper.haveFour(row) + '米';
    },
    formaUnitH: function formaUnitH(row) {
      return helper.reservedDigits(row) + '毫米';
    }
  },
  methods: {
    initData: function initData() {
      this.getMdtksList();
    },
    // 获取二维码信息
    getMdtksList: function getMdtksList() {
      var _this2 = this;

      var timeNewVal = this.helper.getTime(this.searchForm.timeValue);
      this.searchForm.start_time = timeNewVal.startTime;
      this.searchForm.end_time = timeNewVal.endTime;
      this.searchForm.page_no = this.currentPage;
      get(mdtkAPI.getMdtks, this.searchForm).then(function (res) {
        if (res.data.code === 0) {
          _this2.loading = false;
          _this2.tableData = res.data.data.list;
          _this2.totalPage = res.data.data.total;
          _this2.btn = res.data.data.btn;
          setTimeout(function () {
            _this2.loadFlag = false;
          }, 500);
        }
      });
    },
    // 转换二维码图片
    formatPicForQrCode: function formatPicForQrCode(scope, type) {
      return this.helper.picUrl(scope.mqcd_image, type, scope.create_time);
    },
    // 删除
    remove: function remove() {
      var _this3 = this;

      if (this.multipleSelection.length === 0) {
        return this.$message.warning('至少选择一条数据');
      }

      this.$confirm('此操作将永久删除该材料, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var ids = _this3.multipleSelection.map(function (_ref) {
          var mdtk_id = _ref.mdtk_id;
          return Object.values({
            mdtk_id: mdtk_id
          }).toString();
        });

        post(mdtkAPI.destroyMdtkByIds, {
          mdtk_id_list: ids
        }).then(function (res) {
          if (res.data.code === 0) {
            _this3.$message.success(res.data.msg);

            if (ids.length === _this3.tableData.length) {
              if (_this3.currentPage > 1) {
                _this3.currentPage = _this3.currentPage - 1;
                _this3.$refs.pubPagination.currentPage = _this3.currentPage;
              }
            }

            _this3.getMdtksList();

            return;
          }

          _this3.$message.warning(res.data.msg);
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 刷新
    buttonRefresh: function buttonRefresh() {
      this.searchForm = {
        page_no: 1
      };

      if (this.isDyj) {
        this.searchForm.belo_dept_id = this.beloDeptId;
      } else {
        this.searchForm.belo_dept_id = null;
        this.$refs.selectSectionType.value2 = '全部';
      }

      this.loadFlag = true;
      this.currentPage = 1;
      this.getMdtksList();
      this.$refs.pubPagination.currentPage = 1;
    },
    // 图片类型
    formatPic: function formatPic(scope, type) {
      return this.helper.picUrl(scope.row.imge_url, type, scope.row.create_time);
    },
    // 转换合同状态
    getStatusName: function getStatusName(status) {
      if (status === 1) {
        return {
          name: '库存充足',
          type: 'success'
        };
      } else if (status === 0) {
        return {
          name: '库存不足',
          type: 'warning'
        };
      }
    },
    // 查询方法
    getMdtksNow: function getMdtksNow() {
      this.loadFlag = true;
      this.$refs.pubPagination.currentPage = 1;
      this.currentPage = 1;
      this.getMdtksList();
    },
    // 状态查询
    getStatusVal: function getStatusVal(val) {
      this.searchForm.status = val;
    },
    // 分页查询
    changePageSearch: function changePageSearch(val) {
      this.currentPage = val;
      this.getMdtksList();
    },
    // 材料类型
    formatLeavType: function formatLeavType(row) {
      if (row.mdrl_type === 1) {
        return '主材料';
      } else if (row.mdrl_type === 2) {
        return '辅材料';
      } else if (row.mdrl_type === 3) {
        return '其他';
      }
    },
    // 时间转换
    formatDate: function formatDate(row) {
      return this.helper.toStringDate(row.update_time);
    },
    //查询范围
    getStatusVal2: function getStatusVal2(val) {
      this.searchForm.belo_dept_id = val;
    },
    //升序 降序
    sortChange: function sortChange(val) {
      if (val.prop) {
        if (val.order === 'ascending') {
          this.searchForm.mdrl_sort = 'asc';
          this.searchForm.mdrl_field = val.prop;
        } else if (val.order === 'descending') {
          this.searchForm.mdrl_sort = 'desc';
          this.searchForm.mdrl_field = val.prop;
        } else {
          this.searchForm.mdrl_sort = '';
          this.searchForm.mdrl_field = '';
        }
      } else {
        if (val.order === 'ascending') {
          this.searchForm.flag = 0;
        } else if (val.order === 'descending') {
          this.searchForm.flag = 1;
        } else {
          this.searchForm.flag = 0;
        }
      }

      this.loadFlag = true;
      this.searchForm.page_no = 1;
      this.getMdtksList();
    },
    //二维码信息按钮
    getQrCodeData: function getQrCodeData(row) {
      this.qr_mdrl_id = row.mdrl_id;
      this.getQrCodeDataMain(this.qr_mdrl_id);
    },
    // 获取二维码信息接口
    getQrCodeDataMain: function getQrCodeDataMain(id) {
      var _this4 = this;

      get(mdtkAPI.getMdtkMqcds, {
        mdrl_id: id
      }).then(function (res) {
        if (res.data.code === 0) {
          _this4.qrCodeList = res.data.data.list;
          _this4.dialogVisible = true;
          return;
        }

        _this4.$message.error(res.data.msg);
      });
    },
    // 关闭弹窗
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    // 删除二维码确认
    delQrCode: function delQrCode(item) {
      var _this5 = this;

      this.$confirm('确定删除该二维码？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        post(mqcdAPI.deleteMqcdByIds, {
          mqcd_id_list: [item.mqcd_id]
        }).then(function (res) {
          var mg = res.data.msg;

          if (res.data.code === 0) {
            var tp = 'success';

            _this5.$message({
              message: mg,
              type: tp
            });

            _this5.getQrCodeDataMain(_this5.qr_mdrl_id);
          } else {
            var _tp = 'error';

            _this5.$message({
              message: mg,
              type: _tp
            });

            _this5.getQrCodeDataMain(_this5.qr_mdrl_id);
          }
        });
      });
    }
  }
};